// Address types and formatters for the backend address-search endpoints
// (/api/v1/properties/addresses/*). The browser never calls a third-party address
// API directly — DAWA was shut down 2026-10-01; the backend now proxies Gsearch.

/** A house number (DAR husnummer; DAWA called it adgangsadresse). */
export interface AccessAddress {
  id: string
  vejnavn: string
  husnr: string
  postnr: string
  postnrnavn: string
  kommunekode: string | null
  vejkode: string | null
}

/** A unit address (etage/dør) under a house number. */
export interface UnitAddress {
  id: string
  vejnavn: string
  husnr: string
  etage: string | null
  doer: string | null
  postnr: string
  postnrnavn: string
}

export interface AddressSearchResponse<T> {
  /** false = address search not available — user types the address manually. */
  available: boolean
  items: T[]
}

export function formatAdgangsadresse(a: AccessAddress): string {
  return `${a.vejnavn} ${a.husnr}, ${a.postnr} ${a.postnrnavn}`
}

export function formatEnhed(a: UnitAddress): string {
  const unit = [a.etage, a.doer].filter(Boolean).join(' ')
  return `${a.vejnavn} ${a.husnr}${unit ? ', ' + unit : ''}, ${a.postnr} ${a.postnrnavn}`
}
